document.addEventListener('DOMContentLoaded', () => {
  const classInitTheme = new animationsMoonLiteTheme();

  // Initialize each scroll-animated section only as it nears the viewport.
  // Initializing every section synchronously here forced ~800ms of layout
  // reflow at load (TBT); per-section lazy init spreads that cost and skips
  // sections the visitor never scrolls to.
  const themeSectionFetched = document.querySelectorAll('[animatedSection]');
  if (themeSectionFetched.length > 0) {
    const initSection = (section) => {
      const methodTheme = section.getAttribute('methodSection')?.trim();
      if (methodTheme && typeof classInitTheme[methodTheme] === 'function') {
        classInitTheme[methodTheme](section);
      }
    };
    if ('IntersectionObserver' in window) {
      const sectionObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.unobserve(entry.target);
              initSection(entry.target);
            }
          });
        },
        { rootMargin: '300px 0px 300px 0px' }
      );
      themeSectionFetched.forEach((section) => sectionObserver.observe(section));
    } else {
      themeSectionFetched.forEach(initSection);
    }
  }
  const animateElements = document.querySelectorAll('[animate-element]');
  if (animateElements.length > 0) {
    const animateView = new AnimateOnView();
    // CUSTOM(perf/audit-0611): replaces animateView.animateFirstLoad().
    // That path runs gsap.set per element, and GSAP's first touch of each
    // target calls getComputedStyle — interleaving reads & writes across all
    // [animate-element] nodes (~37 on home) into a ~35ms forced-reflow long
    // frame at DOMContentLoaded. Writing inline styles only (no reads)
    // removes the reflow; AnimateOnView.animate() still takes over with
    // gsap.to() on intersection, which parses the inline transform at that
    // point — off the load-critical path. fade-up-large keeps the original
    // gsap.set because its yPercent state cannot round-trip through inline
    // percentage transforms (GSAP would re-read it as a px offset).
    const setInitialNoReflow = (el) => {
      // PDP animations can be proximity-loaded. If a fast user has already
      // reached this element, never hide already-visible content just to play
      // its entrance effect; the observer will safely settle final values.
      const rect = el.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) return;
      const type = el.dataset.animate || 'fade-up';
      switch (type) {
        case 'fade-up':
          el.style.opacity = '0';
          el.style.transform = 'translateY(50px)';
          break;
        case 'fade-in':
          el.style.opacity = '0';
          break;
        case 'fade-right':
          el.style.opacity = '0';
          el.style.transform = 'translateX(-50px)';
          break;
        case 'media-zoom-effect': {
          const media = el.querySelector('img, video');
          if (media) {
            const initialScale = parseFloat(el.dataset.zoomInitial) || 1.1;
            media.style.transform = `scale(${initialScale})`;
          }
          break;
        }
        default:
          // fade-up-large or unknown future types: original behavior.
          animateView.animateIntial(el);
      }
    };
    animateElements.forEach(setInitialNoReflow);
    animateView.observeNewElements();
  }
});
window.addEventListener('resize', () => {
  const themeSectionFetched = document.querySelectorAll('[animatedSection]');
  if (themeSectionFetched.length > 0) {
    setTimeout(() => ScrollTrigger.refresh(true), 2500);
  }
});
